import { Component } from "react";
import { ErrorBlockWrapper, ErrorMessagekWrapper } from "./styles";
import { Button } from "../common/ui/widgets";
import { useTranslation, withTranslation } from "react-i18next";

export const NotFound = () => {
  const { t } = useTranslation();
  return (
    <ErrorMessagekWrapper data-testid="error-message-wrapper">
      <div data-testid="not-found">
        <h1>404</h1>
        <span>Page Not Found</span>
        <p>We are sorry but the page you are looking for does not exist.</p>
        <Button 
        primary
        handleOnClick={() => window.history.back()}>
          {t("Go back")}
        </Button>
      </div>
    </ErrorMessagekWrapper>
  );
}


class ErrorBlock extends Component {
  constructor() {
    super();
    this.state = { hasError: false };
  }
  componentDidCatch(err) {
    this.setState({ hasError: true });
    console.log(err);
  }
  render() {
    const { t } = this.props;
    return (
      <>
        {this.state.hasError ? (
          <ErrorBlockWrapper data-testid="error-block-wrapper">
            {t("an_error_occurred")}
          </ErrorBlockWrapper>
        ) : (
          this.props.children
        )}
      </>
    );
  }
}
export default withTranslation()(ErrorBlock);
